import { fetchContestsSuccess } from "modules/actions/contests_trivia";
import { ISettingsReducer } from "modules/reducers/settings";
import { ITriviaQuestion } from "modules/reducers/trivia";
import * as ENUMS from "modules/utils/enums";
import {IRoundLogos} from "modules/utils/trivia";

import { createReducer } from "redux-act";


type T_ID = number;

export interface ITriviaRound {
	id: T_ID
	position: number,
	category: string
	subcategory: string
	name: IRoundLogos,
	is_sponsored:  boolean
	sponsor:  null | ENUMS.EnumSponsors
	number_questions: number
	points_per_question: number
	questions: ITriviaQuestion[]
	start_date_time: string
	status: ENUMS.EnumTriviaStatusType
	time_to_answer: number
	time_until_next_round: number
	type: ENUMS.EnumTriviaRoundType
	tag_line: string;
}

export interface ITriviaContest {
	id: T_ID;
	name: string;
	start_date_time: string;
	end_date_time: string;
	voided_at: string;
	is_herd: boolean;
	region: ISettingsReducer['region'];
	sponsor?: ENUMS.EnumSponsors;
	number_rounds: number;
	time_between_rounds: number;
	rounds: ITriviaRound[];
	status: ENUMS.EnumTriviaContestStatus;
	type: ENUMS.EnumTriviaContestType;
	position: number | null;
	linked_contest_id: number | null;
	is_replayed?: boolean
}

export type ITriviaContests = ITriviaContest[];

const contests: ITriviaContests = [];

export const contests_trivia = createReducer<ITriviaContests>({}, contests)
	.on(fetchContestsSuccess, (_state, payload) => [
		...payload
	]);
